import AntdStepsWithPanel from 'components/AntdStepsWithPanel/index'
import Button from 'components/Button/index'
import { CollapseComp } from 'components/CollapseStyle/index'
import UpdateStatus from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/InterviewDetails/UpdateStatus/index'
import {
  Container,
  LeftDiv,
  RoundDiv,
  StepRoundFlex,
  StepsFlex,
  StickyDiv,
  Titlediv,
} from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/InterviewDetails/style'
import DriveStatus from 'modules/Exp-Candidates/ViewDriveRole/IndividualDriveTable/DriveStatus/index'
import CollapseText from 'modules/Exp-Candidates/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/InterviewDetails/CollapseText/index'
import React, { useEffect, useState } from 'react'
import { getZeroBeforeInt } from 'utils/getZeroBeforeInt'

const { Panel } = CollapseComp

const RoundsSteps = ({
  setScheduleDrawer,
  setCreateSlotDrawer,
  setCandidateInfo,
  rolesMetrics,
  candidateInterviewDetails,
  candidateInfoData,
  updateInterviewStatus,
  driveId,
  roleId,
  getCandidateList,
  selectedRoundType,
  getRoleMetrics,
  setSelectedCandidate,
  setSelectedCandidateId,
  getSingleCandidateInterviewDetails,
}) => {
  const [current, setCurrent] = useState(null)
  const [updateStatus, setUpdateStatus] = useState(false)
  const [completedStep, setCompletedStep] = useState()

  useEffect(() => {
    let names = rolesMetrics[0]?.rounds?.map(({ roundName }, index) => {
      return roundName
    })
    setCompletedStep(names?.indexOf(candidateInfoData?.stage))
  }, [candidateInfoData, rolesMetrics])

  const onChange = value => {
    setCurrent(value)
  }

  const getCurrentRoundInfo = roundName => {
    let roundInfo =
      candidateInterviewDetails?.candidateInterviewDetails?.filter(data => {
        if (data?.interview?.interviewRound === roundName) {
          return data
        }
      })[0]
    return roundInfo
  }

  const handleSlot = () => {
    setCreateSlotDrawer(true)
    setCandidateInfo(false)
  }
  const handleSchedule = () => {
    setScheduleDrawer(true)
    setCandidateInfo(false)
  }

  const handleUpadate = () => {
    setUpdateStatus(true)
    setCandidateInfo(false)
  }

  const genExtra = () => {
    return (
      <StepRoundFlex>
        {candidateInfoData?.status === 'SCHEDULED' ||
        candidateInfoData?.status === 'HOLD' ? (
          selectedRoundType?.type !== 'EXTERNAL_ASSESMENT' ? (
            <Button.Primary
              width="117px"
              height="32px"
              text="Update Status"
              onClick={handleUpadate}
            />
          ) : (
            ''
          )
        ) : (
          selectedRoundType?.type !== 'GROUP' &&
          candidateInfoData?.status !== 'REJECTED' &&
          candidateInfoData?.status !== 'SELECTED' && (
            <>
              <Button.Secondary
                width="84px"
                height="32px"
                text="Schedule"
                onClick={handleSchedule}
              />
              {selectedRoundType?.type !== 'ASSESMENT' &&
                selectedRoundType?.type !== 'EXTERNAL_ASSESMENT' && (
                  <Button.Primary
                    width="84px"
                    height="32px"
                    text="Create Slot"
                    onClick={handleSlot}
                  />
                )}
            </>
          )
        )}
        {(candidateInfoData?.status === 'SELECTED' ||
          candidateInfoData?.status === 'REJECTED') && (
          <div>
            <DriveStatus
              status={candidateInfoData?.status}
              offerStatus={candidateInfoData?.offerStatus}
            />
          </div>
        )}
      </StepRoundFlex>
    )
  }

  const stepsData = rolesMetrics[0]?.rounds
    ?.slice(0, rolesMetrics[0]?.rounds?.length - 1)
    ?.map((round, index) => {
      return {
        key: index,
        activeKey: index,
        title: (
          <CollapseComp
            key={index + 'stepsData'}
            defaultActiveKey={
              candidateInfoData?.stage === round?.roundName && [index + 1]
            }
            onChange={onChange}
            value={current}
            expandIconPosition={'end'}
            accordion
            bordered={
              candidateInfoData?.stage === round?.roundName &&
              candidateInfoData?.status !== 'SHORTLISTED'
            }
          >
            <Panel
              header={
                <StepsFlex spaceBetween>
                  <StepRoundFlex column>
                    <RoundDiv>Round {getZeroBeforeInt(index + 1)}</RoundDiv>
                    <Titlediv>{round?.roundName}</Titlediv>
                  </StepRoundFlex>
                  {candidateInfoData?.stage === round?.roundName && genExtra()}
                </StepsFlex>
              }
              key={index + 1}
              collapsible={
                getCurrentRoundInfo(round?.roundName) === false &&
                candidateInterviewDetails?.candidateInterviewDetails?.length !==
                  0 &&
                'disabled'
              }
            >
              {!!getCurrentRoundInfo(round?.roundName) !== false && (
                <p>
                  <CollapseText
                    interviewRoundInfo={getCurrentRoundInfo(round?.roundName)}
                    interviwerDeatils={
                      candidateInterviewDetails?.interviewerDetails?.data
                        ?.interviewere
                    }
                    candidateInfoData={candidateInfoData}
                  />
                </p>
              )}
            </Panel>
          </CollapseComp>
        ),
      }
    })
  return (
    <>
      <Container>
        <LeftDiv>
          <StickyDiv>
            <AntdStepsWithPanel current={completedStep} steps={stepsData} />
          </StickyDiv>
        </LeftDiv>
      </Container>
      {updateStatus && (
        <UpdateStatus
          updateStatus={updateStatus}
          setUpadateStatus={setUpdateStatus}
          setCandidateInfo={setCandidateInfo}
          candidateInfoData={candidateInfoData}
          candidateInterviewDetails={candidateInterviewDetails}
          interviwerDeatils={
            candidateInterviewDetails?.interviewerDetails?.data?.interviewere
          }
          rolesMetrics={rolesMetrics}
          updateInterviewStatus={updateInterviewStatus}
          driveId={driveId}
          roleId={roleId}
          getCandidateList={getCandidateList}
          getRoleMetrics={getRoleMetrics}
          setSelectedCandidate={setSelectedCandidate}
          setSelectedCandidateId={setSelectedCandidateId}
          getSingleCandidateInterviewDetails={
            getSingleCandidateInterviewDetails
          }
        />
      )}
    </>
  )
}

export default RoundsSteps
